
import { beheerResource } from '../../../admin/resource';
import { PureConnect, React } from '../../../react';

import cx from './style.less';
import selectorsAdmin from '../../../admin/selectors';

export const DeadLineLabel = PureConnect('DeadLineLabel')(
    (state) => ({
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({
    }),
    ({ beheer }) => {
        const min2=-2;
        var admin = beheer && beheer.qAny() && beheer.qFirst();

        let urgency= !(admin)? 'no-urgency' :
            (!admin.deadlineanswer? 'no-urgency':
                (isValidDate(new Date(admin.deadlineanswer).getDate()) && (getDaysBetweenDates(new Date(new Date(admin.deadlineanswer)), new Date(new Date().getTime())))<0 ?
                    'urgency-just-show' :
                    (isValidDate(new Date(admin.deadlineanswer).getDate()) && (getDaysBetweenDates(new Date(new Date(admin.deadlineanswer)), new Date(new Date().getTime())))>=0 ? 
                            'urgency-alarm':
                            'urgency-unknown'
                    )
                )
            );

        var txtMessage = admin && admin.deadlineanswer && isValidDate(admin.deadlineanswer as Date) ? 'Deadline beantwoording technische vragen: ' + new Date(admin.deadlineanswer).getFullYear() + '-' + 
            ('0' + (new Date(admin.deadlineanswer).getMonth() + 1)).slice(min2) + '-' + 
            ('0' + new Date(admin.deadlineanswer).getDate()).slice(min2): '';

        return (
            <span className={cx('component-deadline','filter')}>                
                <span id={'k-deadline-answer'} className={cx('text', urgency)}>{txtMessage}</span>                
            </span>
        );
    },
);

export const DeadLineLabelFlyover = PureConnect('DeadLineLabelFlyover')(
    (state) => ({
        beheer: beheerResource.selectors.items(state),
        deadlinequestion: selectorsAdmin.deadlinequestion(state),
    }),
    (dispatch) => ({
    }),
    ({ beheer }) => {
        const min2=-2;
        var admin = beheer && beheer.qAny() && beheer.qFirst();

        let urgency= !(admin)? 'no-urgency' :
            (!admin.deadlinequestion? 'no-urgency':
                (isValidDate(new Date(admin.deadlinequestion).getDate()) && (getDaysBetweenDates(new Date(new Date(admin.deadlinequestion)), new Date(new Date().getTime())))<0 ?
                    'urgency-just-show' :
                    (isValidDate(new Date(admin.deadlinequestion).getDate()) && (getDaysBetweenDates(new Date(new Date(admin.deadlinequestion)), new Date(new Date().getTime())))>=0 ? 
                            'urgency-alarm':
                            'urgency-unknown'
                    )
                )
            );

        var txtMessage = admin && admin.deadlinequestion && isValidDate(admin.deadlinequestion as Date) ? 'Deadline aanmaken technische vragen: ' + new Date(admin.deadlinequestion).getFullYear() + '-' + 
            ('0' + (new Date(admin.deadlinequestion).getMonth() + 1)).slice(min2) + '-' + 
            ('0' + new Date(admin.deadlinequestion).getDate()).slice(min2): 'Deadline aanmaken technische vragen: -';

        return (
            <span className={cx('component-deadline','flyover')}>                
                <span id={'k-deadline-answer'} className={cx('text', urgency)}>{txtMessage}</span>                
            </span>
        );
    },
);

function isValidDate(dateval: any) {
    return !isNaN(new Date(dateval).getDate());
}

function getDaysBetweenDates(d0: Date, d1: Date) {

    var msPerDay = 8.64e7;
    const twelfe = 12;
  
    // Copy dates so don't mess them up
    var x0: any = new Date(d0);
    var x1: any = new Date(d1);
  
    // Set to noon - avoid DST errors
    x0.setHours(twelfe,0,0);
    x1.setHours(twelfe,0,0);
  
    // Round to remove daylight saving errors
    return Math.round( (x1 - x0) / msPerDay );
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/deadlineLabel/deadlineLabel.tsx